export default __webpack_public_path__ + "static/media/logo-full-2.5add9dc9.png";